/**
 * Casamento de nomes de produto entre Lotes e Produto por Palete.
 */

import { normalizarTextoProdutoImportacao } from './resolverProdutoPontuacao';

/** Chave canônica para comparar produto (acentos, BERLIM→BERLIN, typo BALCÒO→BALCAO). */
export function normalizarNomeProdutoPalete(texto: string): string {
  return normalizarTextoProdutoImportacao(String(texto || ''))
    .replace(/\bBALCO\b/g, 'BALCAO');
}

export function encontrarProdutoPalete(
  nomeLote: string,
  produtos: ReadonlyArray<{ produto: string }>
): { produto: string; chave: string } | null {
  const alvo = normalizarNomeProdutoPalete(nomeLote);
  if (!alvo) return null;

  for (const p of produtos) {
    const chave = normalizarNomeProdutoPalete(p.produto);
    if (chave === alvo) {
      return { produto: p.produto, chave };
    }
  }
  return null;
}

/** Produtos presentes em Lotes mas ainda ausentes na config da palete. */
export function coletarProdutosPaleteDeLotes(
  lotes: ReadonlyArray<{ produtoNome: string }>,
  produtosPalete: ReadonlyArray<{ produto: string }>
): string[] {
  const existentes = new Set(
    produtosPalete.map((p) => normalizarNomeProdutoPalete(p.produto)).filter(Boolean)
  );
  const novos: string[] = [];

  for (const lp of lotes) {
    const nome = String(lp.produtoNome || '').trim();
    if (!nome) continue;
    const chave = normalizarNomeProdutoPalete(nome);
    if (!chave || existentes.has(chave)) continue;
    existentes.add(chave);
    novos.push(nome.toUpperCase());
  }

  return novos;
}
